import React, { useEffect, useRef, useState } from "react";
import { VideoSeasonProps } from "../../store/actionType";
import EditSeason from "../EditSeason";
import FolderCard from "modules/video/components/FolderCard";
import MenuDropdown from "modules/video/components/MenuDropdown";
import { SmallScreenModel } from "components";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { deleteVideoSeason } from "../../store/action";
import { connect, useSelector } from "react-redux";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

interface SeasonProps {
  seasonData: VideoSeasonProps;
  onClick: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & SeasonProps;
const SeasonCard: React.FC<Props> = ({
  seasonData,
  onClick,
  onDeleteSeason,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEidtFormOpen, setIsEidtFormOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const ref = useRef<HTMLDivElement>(null);
  const videoSeasonsState = useSelector(
    (state: any) => state.videoSeasons.videoSeasonsState
  );
  const closeModal = () => {
    setIsEidtFormOpen(false);
  };
  const handleMenuClick = (e: any) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSeasonClick = () => {
    if (!isMenuOpen) {
      onClick();
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };
  const handleCopySeasonId = (e: any) => {
    e.stopPropagation();
    navigator.clipboard.writeText(seasonData.id);
  };
  const input = {
    season_id: seasonData.id.toString(),
    folder_id: seasonData.folder_id.toString(),
  };
  const handleDeleteSeason = (e: any) => {
    e.stopPropagation();
    onDeleteSeason(seasonData.id.toString(), seasonData.folder_id.toString());
  };
  const toggleEditModal = () => {
    setIsEidtFormOpen(!isEidtFormOpen);
  };

  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  useEffect(() => {
    setDeleteError(videoSeasonsState.error);
    if (videoSeasonsState.error) {
    } else {
      setIsDeleteDialogOpen(false);
    }
  }, [videoSeasonsState.error]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_SEASON));
  return (
    <>
      <FolderCard
        clickedFolder={handleSeasonClick}
        clickedMenu={handleMenuClick}
        title={seasonData.title}
        description={seasonData.title}
        ref={ref}
      >
        {isMenuOpen && (
          <>
            {isPermitted ? (
              <MenuDropdown
                clickedEdit={toggleEditModal}
                copyId={seasonData.id}
                clickedDelete={toggleDeleteDialog}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </>
        )}
      </FolderCard>
      <SmallScreenModel
        showModal={isEidtFormOpen}
        setShowModal={setIsEidtFormOpen}
      >
        {" "}
        <EditSeason closeModal={closeModal} seasonData={seasonData} />
      </SmallScreenModel>
      <SmallScreenModel
        setShowModal={setIsDeleteDialogOpen}
        showModal={isDeleteDialogOpen}
      >
        {" "}
        <ConfirmationDialogMsg
          title={"Delete Season"}
          message={"Are you sure you want to delete?"}
          onConfirm={handleDeleteSeason}
          onCancel={toggleDeleteDialog}
          folderName={seasonData.title}
          error={deleteError}
        />
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onDeleteSeason: (season_id: string, folder_id: string) =>
    dispatch(deleteVideoSeason(folder_id, season_id)),
});

export default connect(null, mapDispatchToProps)(SeasonCard);
